var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("static-loading-indicator-icon"),
      _vm._v(" "),
      _vm.post !== null
        ? _c("div", [
            _c("div", { staticClass: "card shadow-sm" }, [
              _c("img", {
                staticClass: "card-img-top rounded",
                attrs: { src: _vm.post.thumbnail_url },
                on: {
                  load: function($event) {
                    _vm.imageLoaded = true
                  }
                }
              }),
              _vm._v(" "),
              !_vm.imageLoaded
                ? _c(
                    "div",
                    {
                      staticClass: "text-center bg-light",
                      staticStyle: {
                        "padding-top": "80px",
                        "padding-bottom": "80px"
                      }
                    },
                    [
                      _c("i", {
                        staticClass:
                          "mdi mdi-spin mdi-autorenew mdi-36px text-primary"
                      })
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                _c("h3", { staticClass: "oswald" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.post.title) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "span",
                    {
                      staticClass:
                        "text-muted font-weight-bolder mt-2 text-small"
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$date(_vm.post.creted_at).format("DD.MM.YYYY")
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("p", {
                  staticClass: "mt-4",
                  domProps: { innerHTML: _vm._s(_vm.post.contents) }
                }),
                _vm._v(" "),
                _vm.post.files.length
                  ? _c(
                      "div",
                      { staticClass: "mt-5" },
                      [
                        _c("hr"),
                        _vm._v(" "),
                        _c("page-header", {
                          attrs: {
                            title: _vm.$t("pages.locker.my_blog.downloads")
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "row" },
                          _vm._l(_vm.post.files, function(file) {
                            return _c(
                              "div",
                              { staticClass: "col-md-4 col-12 mb-4" },
                              [
                                _c("div", { staticClass: "card bg-light" }, [
                                  _c("div", { staticClass: "card-body" }, [
                                    _c("i", {
                                      staticClass:
                                        "mdi mdi-file-document-box-outline"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-primary font-weight-bold oswald"
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(file.name) +
                                            "\n                                    "
                                        )
                                      ]
                                    ),
                                    _vm._v(
                                      "\n                                    (" +
                                        _vm._s(
                                          _vm.convertBytesToHumanReadable(
                                            file.size
                                          )
                                        ) +
                                        ")\n                                    "
                                    ),
                                    _c("div", { staticClass: "mt-3" }, [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "btn btn-outline-dark btn-sm",
                                          attrs: {
                                            href: file.url,
                                            target: "_blank"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                _vm.$t(
                                                  "pages.subscription.invoices.download"
                                                )
                                              ) +
                                              "\n                                        "
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                ])
                              ]
                            )
                          }),
                          0
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }